
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"120","height":"120"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M55.15 107.44l.03-24.8-18.05-18.33-18.05 18.33v24.8l81.84-.36V57.69H79.86v49.39"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M81.26 57V45.67l9.13-35.62 9.12 35.62v12.15"}}),_c('circle',{attrs:{"cx":"37.13","cy":"83.75","r":"5","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M90.39 1.04v11.28M37.01 63.95h42.85M55.05 82.75h24.81M87.39 5.42h6M80.79 46h19"}})])
          )
        }
      }
    